import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const OurVision = () => {
     useEffect(() => {
        document.title = 'Our Vision -  Mary Matha Cmi  Academy';   
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
        <li><Link to="/"> Home</Link> </li> 
        <li>  School </li> 
        <li>Our Vision </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Our Vision  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <p> The CMI Vision of Education aims at forming leaders who are intellectually competent, spiritually matured, morally upright, psychologically integrated, physically healthy and socially acceptable who will champion the cause of justice, love, truth and peace and who are ever open to further growth.</p>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default OurVision
